import { createDivIn, createImgIn, createHeaderIn, createLinkIn, createParagraphIn, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { doActionIfLoggedIn, isPurchaseUnavailableOnPlatform, showUnavailableOnMobilePopup } from '../../../shared/scripts/store/StoreUtils.ts';
import { UIAPIEndpoints } from '../../../shared/scripts/network/UIAPIEndpoints.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { sendPurchaseSessionStartedAnalytic } from '../analytics/sendPurchaseFunnelAnalytic.ts';
export class UICoinProductView {
    handleBuyButtonClicked(onClickEvent) {
        AudioManager.play(AudioType.Click);
        if (isPurchaseUnavailableOnPlatform()) {
            showUnavailableOnMobilePopup();
            return;
        }
        if (onClickEvent) onClickEvent();
        doActionIfLoggedIn(()=>{
            if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
            sendPurchaseSessionStartedAnalytic({
                storeProductType: this.product.storeProductType,
                productType: this.product.type,
                method: 'stripeCheckout'
            });
            navigateToPage(this.productUrl);
        });
    }
    constructor(container, product, onClickEvent, localizedPriceData){
        this.product = product;
        const productDiv = createDivIn(container, 'store_page_coin_product', '');
        const bodyDiv = createDivIn(productDiv, 'store_page_coin_product_body', '');
        const img = createImgIn(bodyDiv, product.lobbyImage);
        const headerDiv = createDivIn(productDiv, 'store_page_coin_product_header');
        const coinsTotalText = {
            key: 'strings:storePage.coins.title',
            options: {
                count: product.baseCoinAmount + product.bonusCoinAmount
            }
        };
        const coinsTotal = createHeaderIn(headerDiv, coinsTotalText, '', '', 'H2');
        if (product.bonusCoinAmount != 0) {
            const coinAmount = createParagraphIn(headerDiv, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: product.baseCoinAmount + ' '
                }
            }, '');
            const bonusAmount = createParagraphIn(coinAmount, {
                key: 'strings:storePage.coins.bonusAmount',
                options: {
                    count: product.bonusCoinAmount
                }
            }, 'store_page_coin_product_bonus');
        }
        this.productUrl = UIAPIEndpoints.checkoutProductUrl(product.type);
        var _localizedPriceData_displayPrice;
        const priceValue = (_localizedPriceData_displayPrice = localizedPriceData === null || localizedPriceData === void 0 ? void 0 : localizedPriceData.displayPrice) !== null && _localizedPriceData_displayPrice !== void 0 ? _localizedPriceData_displayPrice : product.getUSDPriceWithSign();
        const priceText = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: priceValue
            }
        };
        this.buyButton = createLinkIn(productDiv, '#', priceText, 'store_button btn_general');
        setElementOnClick(this.buyButton, ()=>this.handleBuyButtonClicked(onClickEvent));
        if (product.bannerText != undefined) {
            const isMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb;
            const bannerDiv = createDivIn(productDiv, isMobile ? 'badge-orange badge-md' : 'badge-orange badge-lg');
            const banner = createParagraphIn(bannerDiv, product.bannerText, '');
        }
    }
}
